export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 50;
export const PAGINATION_SIZE_OPTIONS = [10, 20, 50, 100];
